import React from 'react';
import { CheckCircle } from 'lucide-react';
import GridRow from './GridRow';

// Responsive card grid — replaces the old wide <table> (which forced horizontal scroll) and the
// separate isMobile full-inline-card branch. One column on mobile, 2-3 on wider screens, via pure CSS —
// GridRow itself is now a single unified card component used at every breakpoint. Every prop below is
// passed through unchanged; only the container markup changed.
const ApprovalGrid = ({
  rows,
  role,
  selectedIds,
  onSelect,
  onApprove,
  onReject,
  onEdit,
  onDelete,
  onRowClick,
  tab,
}) => {
  if (rows?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 bg-white rounded-xl border"
        style={{ borderColor: '#e8ddd0' }}>
        <div className="w-14 h-14 rounded-full flex items-center justify-center mb-3"
          style={{ backgroundColor: '#dcfce7' }}>
          <CheckCircle size={28} style={{ color: '#16a34a' }} />
        </div>
        <p className="font-semibold text-sm" style={{ color: '#1f2937' }}>
          {tab === 'pending' ? 'No pending submissions' : 'No live rates found'}
        </p>
        <p className="text-xs mt-1" style={{ color: '#9ca3af' }}>
          {tab === 'pending' ? 'All caught up!' : 'Approve some rates to see them here'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {rows?.map(row => (
        <GridRow
          key={row?.id}
          row={row}
          role={role}
          isSelected={selectedIds?.includes(row?.id)}
          onSelect={onSelect}
          onApprove={onApprove}
          onReject={onReject}
          onEdit={onEdit}
          onDelete={onDelete}
          onRowClick={onRowClick}
          tab={tab}
        />
      ))}
    </div>
  );
};

export default ApprovalGrid;
